import React from "react";
import { useTranslation } from "react-i18next";

import { SelectOptions } from "../../../assets/data/options";
import { Company } from "../../../backend/generated/company-model";
import { CompanyUpdatability } from "../../../backend/generated/update-company-input";
import { isUpdatable } from "../../../backend/types/updatability";
import { CompanyInputTypeUnion, CompanyType } from "../../../store/user/types";
import { SubformProps } from "../../SubformProps";
import { InputFieldPropsUnion } from "../elements/types";
import { KeyUndefinedError, SelectFieldInternal, TextFieldInternal } from "./InputField";

type CompanyFieldDescriptor = {
  [key in keyof InputFieldPropsUnion]: any;
}

export type CompanyInputTypeKey = keyof CompanyInputTypeUnion;

type CompanyFieldProps = SubformProps<CompanyType> & Partial<CompanyFieldDescriptor> & {
  id: CompanyInputTypeKey;
  noLabels?: boolean;
}

export const CompanyField = (props: CompanyFieldProps) : JSX.Element | null => {
  // Subform Props

  const { values } = props;

  // Generated Props

  const id = props.id as CompanyInputTypeKey;

  const disabled = !isUpdatable(
    id,
    new Company(values),
    CompanyUpdatability
  );

  // Hooks

  const { t } = useTranslation();

  // Building Component

  switch (id) {
    case "legalEntityType": {
      return (
        <SelectFieldInternal
          label={t("Legal entity type")}
          placeholder={t("Select...")}
          options={SelectOptions().legalEntityType}
          disabled={disabled}
          { ...props }
        />
      );
    }
    case "name": {
      const text = t("Company Name");
      return (
        <TextFieldInternal
          label={text}
          placeholder={text}
          disabled={disabled}
          { ...props }
        />
      );
    }
    case "registrationNumber": {
      const text = t("Registration number");
      return (
        <TextFieldInternal
          label={text}
          placeholder={text}
          disabled={disabled}
          { ...props }
        />
      );
    }
    case "representativeFirstName": {
      const text = t("Representative first name");
      return (
        <TextFieldInternal
          label={text}
          placeholder={text}
          disabled={disabled}
          { ...props }
        />
      );
    }
    case "representativeLastName": {
      const text = t("Representative last name");
      return (
        <TextFieldInternal
          label={text}
          placeholder={text}
          disabled={disabled}
          { ...props }
        />
      );
    }
    case "tradeRegister": {
      const text = t("Trade register");
      return (
        <TextFieldInternal
          label={text}
          placeholder={text}
          disabled={disabled}
          { ...props }
        />
      );
    }
    default: {
      KeyUndefinedError(id); // Compile-time check for unhandled cases
    }
  }

  return <></>;
}
